import moment from "moment"
import "./ContractTemplates.css"
import {NumberToLetterInt} from "../../../helpers/NumberToLetter"
import {MonthName} from "../../../helpers/MonthName"

export const Undetermined = (user:any) => {
    moment.locale('de')
    const dateNotarialDay = moment(user?.user?.notarialTestimonyDate).format('DD')
    const dateNotarialMonth = MonthName(moment(user?.user?.notarialTestimonyDate).format('MM'))
    const dateNotarialYear = moment(user?.user?.notarialTestimonyDate).format('YYYY')
    const dateNotarial = String(dateNotarialDay)+' '+ dateNotarialMonth + ' ' + String(dateNotarialYear)
    let dateOfBirthText = moment(user?.user?.dateOfBirth).format('LL')
    dateOfBirthText = dateOfBirthText.toUpperCase()
    let type = ''
    let typeUp = ''
    type = type.toUpperCase()
    if(user?.type === 'Indeterminado'){
        type = 'indeterminado'
        typeUp = 'INDETERMINADO'
    }else{
        type = 'determinado'
        typeUp = 'DETERMINADO'
    }

    let dateOfAdmissionDay  = ''
    let dateOfAdmissionMonth = ''
    let dateOfAdmissionYear = ''
    let dateOfAdmissionText = ''

    if(user.dateOfAdmission){
        dateOfAdmissionDay = NumberToLetterInt(moment(user.dateOfAdmission).format('DD'))
        if(dateOfAdmissionDay === 'UN'){
            dateOfAdmissionDay = 'PRIMERO'
        }
        
        dateOfAdmissionMonth = MonthName(moment(user.dateOfAdmission).format('MM'))
        dateOfAdmissionYear = NumberToLetterInt(moment(user.dateOfAdmission).format('YYYY'))
    
        dateOfAdmissionText = dateOfAdmissionDay +' DE '+ dateOfAdmissionMonth + ' DE ' + dateOfAdmissionYear
    }
    let monthRemaining = ''
    let dayRemaining = ''

    if(user?.type !== 'Indeterminado' && user?.dateContractDate && user?.dateOfAdmission){
        monthRemaining = String(moment(user?.dateContractDate).diff(moment(user?.dateOfAdmission), 'months'))
        dayRemaining = String(moment(user?.dateContractDate).diff(moment(user?.dateOfAdmission), 'days'))
    }



    return (
        <div className="conteiner" >
            
            <div className="conteinerTitleText" >
                <p className="titleText" 
                style={{
                    textAlign: "center",
                }}
                ><b>CONTRATO INDIVIDUAL DE TRABAJO POR TIEMPO {typeUp}.</b></p>
            </div>
            <div className="conteinerText" >
                <p className="text" >
                    EN LA CIUDAD DE {user?.user?.municipioEmpresa}, {user?.user?.estadoEmpresa}, A <u>{dateOfAdmissionText}</u>, CELEBRAN POR UNA PARTE <b>"{user?.user?.nameEnterprise}"</b>, REPRESENTADA EN ESTE ACTO POR <b>{user?.user?.legalRepresentative}</b>, EN SU CARÁCTER DE REPRESENTANTE LEGAL A LO QUE EN LO SUCESIVO SE LE DENOMINARÁ INDISTINTAMENTE, COMO <b>"EL PATRÓN"</b> Y POR LA OTRA PARTE <b>{user?.user?.bussinesName}</b>, A QUIEN SE IDENTIFICARÁ COMO <b>"EL TRABAJADOR"</b>; EFECTO PARA EL CUAL, FORMULAN LAS SIGUIENTES:
                </p>
            </div>
            <div className="conteinerTitleText" >
                <p className="titleText" 
                style={{
                    textAlign: "center",
                }}
                >D E C L A R A C I O N E S</p>
            </div>
            <div className="conteinerTitleText" >
                <p className="titleText" >PRIMERA. - “EL PATRON”</p>
            </div>
            <div className="conteinerText" >
                <p className="text" >
                I.- Estar legalmente constituida conforme a las leyes mexicanas como se justifica con el testimonio notarial <b>{user?.user?.notarialTestimony}</b>, volumen <b>{user?.user?.notarialTestimonyVolume}</b>, de fecha <b>{dateNotarial}</b>, pasado ante la fe de la notaría pública número <b>{user?.user?.notaryPublicNumber}, {user?.user?.notaryPublic}</b>, con ejercicio en Distrito Judicial en {user?.user?.judicialDistrict} con Registro Federal de Contribuyentes {user?.user?.taxRegime}.
                </p>
            </div>
            <div className="conteinerText" >
                <p className="text" >
                II.- Que en este acto se encuentra representada por <b>{user?.user?.legalRepresentative}</b>, manifiesta ser Representante Legal de <b>"{user?.user?.nameEnterprise}"</b>, personalidad jurídica que se encuentra acreditada plenamente en términos del testimonio notarial número <b>{user?.user?.notaryPublicNumber}</b>, y que cuenta con todas las facultades necesarias para la celebración del presente contrato.
                </p>
            </div>
            <div className="conteinerText" >
                <p className="text" >
                III.- Tener su domicilio fiscal en <b>{user?.user?.addressEnterprise}</b>.
                </p>
            </div>
            <div className="conteinerText" >
                <p className="text" >
                IV.- Que requiere de los servicios de personal apto para el desarrollo de sus actividades como <b>"{user?.user?.Puesto}"</b>.
                </p>
            </div>
            <div className="conteinerTitleText" >
                <p className="titleText" ><b>"SEGUNDA. - "EL TRABAJADOR"</b></p>
            </div>
            <div className="conteinerText" >
                <p className="text" >
                Por su parte, <b>"EL TRABAJADOR"</b> manifiesta bajo protesta decir verdad lo siguiente:
                </p>
            </div>
            <div className="conteinerText" >
                <p className="text" >
                I.- Llamarse <b>{user?.user?.bussinesName}</b> y actualmente no tiene relaciones laborales con algún otro patrón.
                </p>
            </div>
            <div className="conteinerText" >
                <p className="text" >
                <b>II.- Ser de nacionalidad {user?.user?.nacionality}, sexo {user?.user?.gender}, estado civil {user?.user?.civilStatus}, de {user?.user?.Age} años, con Clave Única de Registro de Población (CURP) {user?.user?.CURP}, con Registro Federal de Contribuyentes (RFC) {user?.user?.RFC}, con fecha de nacimiento el {dateOfBirthText}</b> con domicilio en <b>{user?.user?.address}</b>.
                </p>
            </div>
            <div className="conteinerText" >
                <p className="text" >
                III.- Cuenta con el número de afiliación <b>{user?.user?.IMSS}</b> del Instituto Mexicano del Seguro Social y que no cuenta con antecedentes penales, ni se encuentra obligado por ninguna orden judicial a retenciones de su salario.
                </p>
            </div>
            <div className="conteinerText" >
                <p className="text" >
                IV.- Gozar de buena salud, no sufrir ninguna enfermedad mortal, ni aquella que pueda poner en peligro su vida al realizar las actividades que le sean encomendadas, o que le impidan realizar las mismas.
                </p>
            </div>
            <div className="conteinerText" >
                <p className="text" >
                V.- No tener ningún tipo de crédito ni deuda contratada con instituciones financieras o de cualquier otro tipo.
                </p>
            </div>
            <div className="conteinerText" >
                <p className="text" >
                VI.- Dar aviso en caso de tener créditos contratados con el Instituto del Fondo Nacional de la Vivienda para los Trabajadores (INFONAVIT); así como créditos contratados con el Instituto del Fondo Nacional para el Consumo de los Trabajadores (FONACOT).
                </p>
            </div>
            <div className="conteinerText" >
                <p className="text" >
                VII.- Tener la capacidad y aptitudes, así como los conocimientos profesionales o técnicos necesarios para desarrollar con eficiencia y eficacia, las actividades requeridas por el <b>"EL PATRÓN"</b> o por un tercero al que fuere asignado derivado de la relación contractual previa entre <b>"EL PATRÓN"</b> y sus clientes.
                </p>
            </div>
            <div className="conteinerText" >
                <p className="text" >
                VIII.- Estar de acuerdo en desempeñar las actividades requeridas y ordenadas por <b>"EL PATRÓN"</b> y en observar las condiciones generales de trabajo sobre las cuales prestará sus servicios personales, así mismo no tener inconveniente en ser asignado a la empresa, centro de trabajo, establecimiento, sucursal o lugar que <b>"EL PATRÓN"</b> le indique, siempre que le sean proporcionadas las prestaciones señaladas por la ley en el puesto.
                </p>
            </div>
            <div className="conteinerText" >
                <p className="text" >
                IX.- Continúa declarando <b>"EL TRABAJADOR"</b> que ha recibido una completa explicación de la naturaleza del trabajo que va a desarrollar y que acredita de manera fehaciente con la documentación personal que exhibe, tener conocimientos y aptitudes necesarios para el desarrollo del puesto, por lo que está conforme en prestar sus servicios especializados, profesionales y/o técnicos <b>por tiempo {type} a "EL PATRÓN"</b>{user?.type === 'Indeterminado'? '': ' durante el tiempo que éste último determine' }.
                </p>
            </div>
            <div className="conteinerText" >
                <p className="text" >
                X.- Que el trabajo que desarrollará, así como las funciones, actividades, tareas y en general el servicio o servicios que desempeñará para <b>"EL PATRÓN"</b> o para cualquier tercero al que fuere asignado derivado de la relación contractual previa entre <b>"EL PATRÓN"</b> y sus clientes, es de carácter especializado y que en caso de ser asignado a un tercero derivado de la relación contractual de <b>"EL PATRÓN"</b> con sus clientes, el trabajo que desarrollará no comprenderá tareas iguales o similares a las que realizan el resto de los trabajadores al servicio de dicho tercero, precisamente por el carácter especializado de las funciones que desempeña.
                </p>
            </div>
            <div className="conteinerText" >
                <p className="text" >
                <b>TERCERA. - "LAS PARTES"</b> declaran que reconocen que el presente contrato, adicionalmente se regirá de acuerdo con las bases y lineamientos, establecidos en el Contrato Colectivo de Trabajo que tiene celebrado la parte patronal con antelación a la firma del presente.
                </p>
            </div>
            <div className="conteinerText" >
                <p className="text" >
                Asentado lo anterior, <b>"LAS PARTES"</b> otorgan y suscriben el presente instrumento, mismo que sujetan al tenor de las siguientes:
                </p>
            </div>
            <div className="conteinerTitleText" >
                <p className="titleText" 
                style={{
                    textAlign: "center",
                }}
                >C L A U S U L A S</p>
            </div>
            <div className="conteinerText" >
                <p className="text" >
                <b>PRIMERA.</b> - Para efectos del presente contrato, en lo que lo sucesivo se le denominará a la Ley Federal del Trabajo, como <b>"LA LEY"</b>, al presente documento, como <b>"EL CONTRATO"</b> y a quienes lo suscriben como <b>"LAS PARTES"</b>.
                </p>
            </div>
            {
                user?.type === 'Indeterminado'?(
                    <div className="conteinerText" >
                        <p className="text" >
                        <b>SEGUNDA. - </b>El presente <b>"CONTRATO"</b> de trabajo se estipula <b>por tiempo indeterminado</b> a partir de la fecha de celebración del presente, Se hace del conocimiento a <b>"EL TRABAJADOR"</b> que en caso de que incurra en alguna de las causales de rescisión que señala el artículo 47 de <b>"LA LEY"</b>, será motivo suficiente para concluir de manera definitiva la relación de trabajo sin responsabilidad para <b>"EL PATRÓN"</b> por razones atribuibles a <b>"EL TRABAJADOR"</b>. Además, queda expresamente acordado por <b>"LAS PARTES"</b> que, de no acreditar <b>"EL TRABAJADOR"</b> que satisface los requisitos y conocimientos necesarios para desarrollar las labores a juicio de <b>"EL PATRON"</b> tomando en cuenta la opinión de la Comisión Mixta de Productividad, Capacitación y Adiestramiento en los términos de "LA LEY", así como la naturaleza de la categoría o puesto, se dará por terminada la relación de trabajo, sin responsabilidad para "EL PATRON".
                        </p>
                    </div>
                ):(
                    <div className="conteinerText" >
                        <p className="text" >
                        <b>SEGUNDA. - </b>El presente <b>"CONTRATO"</b> de trabajo se estipula <b>por tiempo determinado de {monthRemaining} meses, equivalente a {dayRemaining} días</b>. contados a partir de la fecha de celebración del presente, vencidos los cuales, sin haberse extinguido la relación laboral, se presumirá de pleno derecho la continuidad de aquella, en virtud de que, si vencido el término que se hubiese fijado subsiste la materia del trabajo, la relación queda prorrogada por todo el tiempo que perdure dicha circunstancia, ello de conformidad con el artículo 39 de <b>"LA LEY"</b>. No obstante, la temporalidad determinada del presente contrato <b>"EL PATRON"</b> hace el conocimiento a <b>"EL TRABAJADOR"</b> que en caso de que incurra en alguna de las causales de rescisión que señala el artículo 47 de <b>"LA LEY"</b>, será motivo suficiente para concluir de manera definitiva la relación de trabajo sin responsabilidad para <b>"EL PATRÓN"</b> por razones atribuibles a <b>"EL TRABAJADOR"</b>. Además, queda expresamente acordado por <b>"LAS PARTES"</b> que, de no acreditar <b>"EL TRABAJADOR"</b> que satisface los requisitos y conocimientos necesarios para desarrollar las labores a juicio de <b>"EL PATRON"</b> tomando en cuenta la opinión de la Comisión Mixta de Productividad, Capacitación y Adiestramiento en los términos de <b>"LA LEY"</b>, así como la naturaleza de la categoría o puesto, se dará por terminada la relación de trabajo, sin responsabilidad para <b>"EL PATRON"</b>.
                        </p>
                    </div>
                )
            }
            

            <div className="conteinerText" >
                <p className="text" >
                <b>TERCERA. -</b> El lugar en que <b>"EL TRABAJADOR"</b> prestará sus servicios, será el que le indique <b>"EL PATRÓN"</b> o el asignado por un tercero derivado de la relación contractual previa entre <b>"EL PATRÓN"</b> y sus clientes, siempre y cuando no se vea menoscabado su salario y/o prestaciones previstas en este instrumento y en <b>"LA LEY"</b>.
                </p>
            </div>
            <div className="conteinerText" >
                <p className="text" >
                De igual forma, <b>"LAS PARTES"</b> convienen y aceptan de mutuo acuerdo que, cuando por razones administrativas, o de desarrollo de la actividad o prestación de los servicios contratados por <b>"EL PATRÓN"</b> con terceros, sea necesario laborar en cualquier otro espacio físico, <b>"EL TRABAJADOR"</b> deberá llevarlos, realizarlos o ejecutarlos en el lugar y condiciones que indique <b>"EL PATRÓN"</b>, para lo cual y para efectos del presente contrato será asignado físicamente a las instalaciones, sin que por ello implique o exista relación laboral con dicho tercero, por lo que a partir de este momento <b>"EL PATRON"</b> le acepta la relación laboral y libera al tercero de esta o de cualquier responsabilidad que se genere a consecuencia de la prestación del servicio.
                </p>
            </div>
            <div className="conteinerText" >
                <p className="text" >
                En este supuesto, <b>"EL PATRÓN"</b> le comunicará con anticipación, el lugar y fecha a partir de la cual habrá de iniciar la prestación de sus servicios, indicándole el lugar que se le hubiere asignado.
                </p>
            </div>
            <div className="conteinerText" >
                <p className="text" >
                Para el caso de que el nuevo lugar que le fuere asignado para prestación de los servicios variara el horario de labores, <b>"EL TRABAJADOR"</b> acepta allanarse a dicha modalidad.
                </p>
            </div>
            <div className="conteinerText" >
                <p className="text" >
                <b>CUARTA. -</b> Así mismo <b>"EL TRABAJADOR"</b> está de acuerdo que los servicios contratados se prestarán con el mayor esmero posible, con la finalidad de demostrar eficiencia, responsabilidad y compromiso laboral. Caso contrario la relación laboral en automático se terminará en el término establecido o bien con anticipación cuando estas circunstancias no se reflejen en la prestación de dicho servicio contratado.
                </p>
            </div>
            <div className="conteinerText" >
                <p className="text" >
                <b>QUINTA. -</b> La duración de la jornada se pacta de conformidad con lo establecido en el Artículo 59 de <b>"LA LEY"</b> y solamente en su caso se aplicará la conducente al Artículo 66 de <b>"LA LEY"</b>.
                </p>
            </div>
            <div className="conteinerText" >
                <p className="text" >
                <b>SEXTA. - "EL TRABAJADOR"</b> percibirá por la prestación de los servicios contratados un salario diario, el cual percibirá por la cantidad de 
                {user?.user.nominesPayroll ==='Mixto'?
                 <b> ${user?.user?.SDG} ({user?.user?.SDGText} M.N.) </b>
                :<b> ${user?.user?.DS} ({user?.user?.DSText} M.N.)</b>
                } mismo que será cubierto {user?.user?.paymentPeridicity}.
                </p>
            </div>
            <div className="conteinerText" >
                <p className="text" >
                Dicho pago deberá efectuarse a través de transferencia electrónica, en la que depositará oportunamente su salario, cuenta que desde luego pertenecerá exclusivamente a <b>"EL TRABAJADOR"</b>, derivado de la relación laboral contraída en <b>"EL CONTRATO"</b>. Soló excepcionalmente el patrón pagará el salario en efectivo y por alguna eventualidad que haya surgido de manera interna.
                </p>
            </div>
            <div className="conteinerText" >
                <p className="text" >
                Del salario anterior, <b>"LAS PARTES"</b> acuerdan sí es procedente, hacer la deducciones legales correspondientes; particularmente, las relativas al Impuesto Sobre la Renta, Seguro Social, cuotas obreras, etc.; haciéndose las aportaciones y enteros correspondientes al IMSS, INFONAVIT, SAR, Autoridades Hacendarias, en términos de las legislaciones respectivas, las que por mandato judicial esté obligado a pagar <b>"EL TRABAJADOR"</b> y <b>"EL PATRÓN"</b> este obligado a retener, así como las cuotas para amortizaciones de crédito INFONAVIT.
                </p>
            </div>
            <div className="conteinerText" >
                <p className="text" >
                <b>"EL PATRÓN"</b> deberá emitir el comprobante fiscal digital por internet (CDFI) de nómina por el periodo de pago correspondiente, donde aparecerá el desglose de los conceptos que paga, e impuestos que en su caso retenga.
                </p>
            </div>
            <div className="conteinerText" >
                <p className="text" >
                <b>SÉPTIMA. - "EL TRABAJADOR"</b> tendrá derecho por cada seis días de labores, a un día de descanso, con pago del salario diario correspondiente.
                </p>
            </div>
            <div className="conteinerText" >
                <p className="text" >
                <b>OCTAVA. -</b> Quedan establecidos como días de descanso obligatorio, los señalados en el Artículo 74 de <b>"LA LEY"</b>.
                </p>
            </div>
            <div className="conteinerText" >
                <p className="text" >
                <b>NOVENA. - "EL TRABAJADOR"</b> tendrá derecho a disfrutar de un periodo anual de vacaciones, según lo previsto en el Artículo 76 de <b>"LA LEY"</b>, de acuerdo con su antigüedad en el trabajo. Durante dicho periodo, disfrutará del salario que le corresponda.
                </p>
            </div>
            <div className="conteinerText" >
                <p className="text" >
                <b>DÉCIMA. - "EL TRABAJADOR"</b> tendrá derecho a recibir la Prima Vacacional respectiva de acuerdo con su antigüedad, esta podrá ser pagada al goce de sus vacaciones o al cumplir el año de servicio según convenga al patrón.
                </p>
            </div>
            <div className="conteinerText" >
                <p className="text" >
                <b>DÉCIMA PRIMERA. - "EL TRABAJADOR"</b> tendrá derecho a recibir por parte de <b>"EL PATRÓN"</b>, antes del día 20 de diciembre de cada año, el importe correspondiente al pago del aguinaldo a que se contrae el numeral 87 de <b>"LA LEY"</b>, o su parte proporcional por fracción de año.
                </p>
            </div>
            <div className="conteinerText" >
                <p className="text" >
                <b>DÉCIMA SEGUNDA. - "EL TRABAJADOR"</b> acepta someterse a los exámenes médicos que periódicamente determine <b>"EL PATRÓN"</b> en los términos de la Fracción X del Artículo 134 de <b>"LA LEY"</b>, a fin de mantener en forma óptima sus facultades físicas e intelectuales, para el mejor desempeño de sus funciones. Los costos respectivos, serán a cargo de <b>"EL PATRÓN"</b>.
                </p>
            </div>
            <div className="conteinerText" >
                <p className="text" >
                <b>DÉCIMA TERCERA. - "EL TRABAJADOR"</b> deberá integrarse a los Planes, Programas y Comisiones Mixtas de Adiestramiento, así como a las de Seguridad e Higiene en el Trabajo que tiene constituidas <b>"EL PATRÓN"</b>, tomando parte activa de las mismas, según los cursos establecidos y medidas preventivas de riesgos de trabajo.
                </p>
            </div>
            <div className="conteinerText" >
                <p className="text" >
                <b>DÉCIMA CUARTA. - "EL TRABAJADOR"</b> deberá observar y cumplir las disposiciones contenidas en el Reglamento Interior de Trabajo con que cuenta <b>"EL PATRÓN"</b>.
                </p>
            </div>
            <div className="conteinerText" >
                <p className="text" >
                <b>DÉCIMA QUINTA. - "EL TRABAJADOR"</b> acepta y, por ende, queda establecido que cuando por razones convenientes para <b>"EL PATRÓN"</b>, o con motivo de lo señalado en la cláusula cuarta de este contrato, ésta modifique el horario de trabajo, desempeñará su jornada en el que quede establecido, ya que sus actividades al servicio de <b>"EL PATRÓN"</b> son prioritarias y no se contraponen a otras que pudiere llegar a desarrollar.
                </p>
            </div>
            <div className="conteinerText" >
                <p className="text" >
                <b>DÉCIMA SEXTA. - "EL TRABAJADOR"</b>, deberá dar cabal cumplimiento a las disposiciones contenidas en el Artículo 134 de <b>"LA LEY"</b>, inherentes a las obligaciones de los trabajadores, en el desempeño de sus labores al servicio de <b>"EL PATRÓN"</b>.
                </p>
            </div>
            <div className="conteinerText" >
                <p className="text" >
                <b>DÉCIMA SÉPTIMA.- "EL TRABAJADOR"</b> acepta, se compromete y obliga a no usar el acceso a la información que le otorga <b>"EL PATRÓN"</b> o la que conozca por un tercero derivado de la relación contractual previa entre <b>"EL PATRÓN"</b> y sus clientes, más allá de las limitaciones y el objeto específico para el cual se le está otorgando el acceso a dicha información; ni divulgar, ni revelar en forma alguna: datos, información, especificaciones, estrategias, técnicas, secretos, métodos, sistemas y en general cualquier mecanismo y documento al cual tendrá acceso, apercibido de cubrir a <b>"EL PATRÓN"</b> o a un tercero derivado de la relación contractual previa entre <b>"EL PATRÓN"</b> y sus clientes, los daños y perjuicios que le causaren en virtud de la violación de cualquiera de las obligaciones contraídas, independientemente de las acciones legales que se generen con motivo de dicho incumplimiento. Asimismo, toda la información contenida y la que en forma expresa o tácita, directa o indirectamente sea recibida por <b>"EL TRABAJADOR"</b> en virtud del acceso que se le da a la misma, se constituye como un secreto industrial de <b>"EL PATRÓN"</b> o a un tercero derivado de la relación contractual previa entre <b>"EL PATRÓN"</b> y sus clientes, en los términos del artículo 82 de La Ley de la Propiedad Industrial y por lo tanto estará sujeta a lo previsto por los numerales 83, 84, 85 y 86, y demás relativos de dicho ordenamiento legal, por lo que obviamente su revelación por cualquier medio, parcial o total caerá en lo previsto por el artículo 213 y 223 de la multicitada ley, generándose como ya se adelantó, el derecho de la afectada de reclamar los daños y perjuicios que por ese motivo se le causen, independientemente de las implicaciones jurídicas en que se compromete el violador de este contrato. Independientemente de los daños y perjuicios que deberá cubrir <b>"EL TRABAJADOR"</b> por la violación a esta cláusula, se obliga también a cubrir una sanción por el monto equivalente al valor del proyecto al cual estará asignado.
                </p>
            </div>
            <div className="conteinerText" >
                <p className="text" >
                <b>DÉCIMA OCTAVA. - "EL TRABAJADOR"</b> deberá presentarse puntualmente a sus labores en el horario de trabajo establecido y firmar las listas de asistencia acostumbradas o bien, checar su tarjeta de asistencia en el reloj-checador diariamente o el método que la empresa designe. En caso de retraso o falta de asistencia injustificada, <b>"EL PATRÓN"</b> podrá imponerle cualquier corrección disciplinaria de las que contempla el Reglamento Interno de Trabajo, o <b>"LA LEY"</b>.
                </p>
            </div>
            <div className="conteinerText" >
                <p className="text" >
                <b>DÉCIMA NOVENA. -</b> Para todo lo no previsto en <b>"EL CONTRATO"</b> se estará a lo prescrito por <b>"LA LEY"</b>, así como en el Reglamento Interior de Trabajo.
                </p>
            </div>
            <div className="conteinerText" >
                <p className="text" >
                <b>VIGESIMA. -</b> Para la debida interpretación y cumplimiento del presente contrato, <b>"LAS PARTES"</b> se someten expresamente, a la jurisdicción de los tribunales competentes de esta {user?.user?.addressCourt}, renunciando expresamente al fuero que pudiera corresponderles por razón de domicilio presente o futuro, o por cualquier otra causa o circunstancia.
                </p>
            </div>
            <div className="conteinerText" >
                <p className="text" >
                LEÍDO QUE FUE EL PRESENTE INSTRUMENTO POR QUIENES EN EL INTERVIENEN E IMPUESTAS DE SU CONTENIDO Y ALCANCE, LOS SUSCRIBEN Y FIRMAN, ANTE LOS TESTIGOS DE ASISTENCIA QUE SE CITAN, EN LA CIUDAD DE {user?.user?.municipality}, {user?.user?.estadoEmpresa}. -- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - HECHO LO ANTERIOR, EL ORIGINAL QUEDARÁ EN PODER DE <b>"EL PATRÓN"</b> Y UNA COPIA EN PODER DE <b>"EL TRABAJADOR”</b>. - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

                </p>
            </div>
            <div className="conteinerTitleText" 
            style={{
                display: "flex",
            }}
            >
                <div
                style={{
                    width: "50%",
                }}
                >
                    <p className="titleText" 
                    style={{
                        textAlign: "center",
                    }}
                    >"EL COLABORADOR"</p>
                </div>
                <div
                style={{
                    width: "50%",
                }}
                >
                    <p className="titleText" 
                    style={{
                        textAlign: "center",
                    }}
                    >"EL PATRON"</p>
                </div>
            </div>
            <div className="conteinerTitleText" 
            style={{
                display: "flex",
            }}
            >
                <div
                style={{
                    width: "50%",
                }}
                >
                    <p className="titleText" 
                    style={{
                        textAlign: "center",
                    }}
                    >_________________________________</p>
                    <p className="titleText" 
                    style={{
                        textAlign: "center",
                    }}
                    >{user?.user?.bussinesName}</p>
                </div>
                <div
                style={{
                    width: "50%",
                }}
                >
                    <p className="titleText" 
                    style={{
                        textAlign: "center",
                    }}
                    >_________________________________</p>
                    <p className="titleText" 
                    style={{
                        textAlign: "center",
                    }}
                    >{user?.user?.legalRepresentative}
                    </p>
                </div>
            </div>
            <div className="conteinerTitleText" >
                <p className="titleText" 
                style={{
                    textAlign: "center",
                }}
                ><b>“TESTIGOS”</b></p>
            </div>
            <div className="conteinerText" >
                <p className="text" >
                AMBOS APERCIBIDOS DE LAS PENAS EN LAS QUE INCURREN LAS PERSONAS QUE SE CONDUCEN CON FALSEDAD MANIFESTADO SU MAYORÍA DE EDAD Y ACEPTANDO AMBOS FUNGIR COMO TESTIGOS EN EL PRESENTE ACTO, LO FIRMAN DE CONFORMIDAD. - - - - - - -- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - 

                </p>
            </div>
            <div className="conteinerTitleText" 
            style={{
                display: "flex",
            }}
            >
                <div
                style={{
                    width: "50%",
                }}
                >
                    <p className="titleText" 
                    style={{
                        textAlign: "center",
                    }}
                    >TESTIGO</p>
                </div>
                <div
                style={{
                    width: "50%",
                }}
                >
                    <p className="titleText" 
                    style={{
                        textAlign: "center",
                    }}
                    >TESTIGO</p>
                </div>
            </div>
            <div className="conteinerTitleText" 
            style={{
                display: "flex",
            }}
            >
                <div
                style={{
                    width: "50%",
                }}
                >
                    <div>
                        <p className="titleText" 
                        style={{
                            textAlign: "center",
                        }}
                        >_________________________________</p>
                    </div>
                    
                    <div className="divC">
                        <p className="titleText" 
                        >C.
                        </p>
                    </div>
                </div>
                <div
                style={{
                    width: "50%",
                }}
                >
                    <div>
                        <p className="titleText" 
                        style={{
                            textAlign: "center",
                        }}
                        >_________________________________</p>
                    </div>
                    
                    <div className="divC">
                        <p className="titleText" 
                        >C.
                        </p>
                    </div>
                    
                </div>
            </div>
            <div className="conteinerText" >
                <p className="text" >
                ESTA HOJA DE FIRMAS CORRESPONDE AL CONTRATO INDIVIDUAL DE TRABAJO POR TIEMPO {typeUp} CELEBRADO ENTRE {user?.user?.nameEnterprise} Y, {user?.user?.bussinesName} DE FECHA {user?.user?.dateOfAdmissionText}.

                </p>
            </div>
        </div>
    )

}